const initialState = {
  loading: false,
};

const loadingReducer = (state = false, action) => {
  switch (action.type) {
    case "setLoading":
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default loadingReducer;
